<template>
  <div class="container-fluid pt-0">
    <AddGroupUser
      v-if="addGroupUserModal"
      :show="addGroupUserModal"
      v-on:closeAddGroupUser="
        addGroupUserModal = false;
        $emit('getSingleDevice', 'users');
      "
    />
    <RemoveGroupUser
      v-if="removeGroupUserModal"
      :show="removeGroupUserModal"
      :removedId="removedId"
      v-on:closeRemoveGroupUser="
        removeGroupUserModal = false;
        $emit('getSingleDevice', 'users');
      "
    />
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      background-color="#f3f3f3"
      :opacity="0.8"
      loader="bars"
    ></loading>
    <!-- <div class="row">
      <div class="col-5">
        <h4 class="p-b-20">{{ $t("users") }}</h4>
      </div>
      <div class="col-7">
        <div class="d-flex align-items-center justify-content-end">
          <button
            data-step="1"
            data-intro="<h5 style='margin-bottom: 1rem; color: #213e7a'>Users</h5>Assign members of your team to monitor selected devices."
            @click="addGroupUserModal = true"
            class="btn btn-primary"
          >
            {{ $t("add_user") }}
          </button>
        </div>
      </div>
    </div> -->
    <div class="card">
      <div class="card-body">
        <div class="mb-5">
          <TableSearch @handleSearch="handleSearch" />
        </div>
        <div class="row">
          <div class="col-12">
            <div class="table-responsive">
              <div
                id="zero_config_wrapper"
                class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer"
              >
                <div class="row" style="height: 25rem; overflow: auto;">
                  <div class="col-sm-12">
                    <table id="order-listing" class="table table-hover display">
                      <thead class="data-table-bg">
                        <tr>
                          <th>{{ $t("full_name") }}</th>
                          <th>{{ $t("email") }}</th>
                          <th>{{ $t("user_rights") }}</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody
                        v-if="singlegroup.users && singlegroup.users.length > 0"
                      >
                        <tr
                          :key="index"
                          v-for="(user, index) in paginatedData"
                          :class="{
                            'data-table-bg': index % 2 !== 0,
                          }"
                        >
                          <td>{{ user.fullname }}</td>
                          <td>{{ user.email }}</td>
                          <td>{{ user.role }}</td>
                          <td>
                            <span
                              class="cursor-pointer"
                              @click="removeuser(user.id)"
                            >
                              <IconDelete />
                            </span>
                          </td>
                        </tr>
                      </tbody>
                      <tbody class="" v-else>
                        <tr align="center">
                          <td colspan="6">
                            <div class="col-md-6 col-lg-5 mx-auto">
                              <h3 class="mt-3">{{ $t("no_user") }}</h3>
                              <p>
                                {{ $t("users_ass") }}
                              </p>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <Pagination
                :pageCount="pageCount"
                :data="dataTable"
                :sizeperpage="sizeperpage"
                :pageNumber="pageNumber"
                :pages="pages"
                @goToLastPage="goToLastPage"
                @nextPage="nextPage"
                @handlePageChange="handlePageChange"
                @goToFirstPage="goToFirstPage"
                @prevPage="prevPage"
                @onchange="onchange"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import vClickOutside from "v-click-outside";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import store from "../../store/index";
import AddGroupUser from "../Modals/AddGroupUser";
import RemoveGroupUser from "../Modals/RemoveGroupUser";
import tableMixin from "../../mixins/tableMixin";
import Pagination from "../../components/PaginationNew.vue";
import TableSearch from "../../components/TableSearch.vue";
import IconDelete from "../../components/Iconsvg/IconDeleteUser.vue";

export default {
  name: "GroupUsers",
  data() {
    return {
      isLoading: false,
      fullPage: true,
      dropdownShow: false,
      removedId: "",
      id: "",
      addGroupUserModal: false,
      removeGroupUserModal: false,
      // singlegroup: {},
    };
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: {
    showModal: String,
  },
  components: {
    Loading,
    AddGroupUser,
    RemoveGroupUser,
    Pagination,
    TableSearch,
    IconDelete,
  },
  mixins: [tableMixin],
  computed: {
    ...mapGetters(["singlegroup"]),
  },
  beforeRouteEnter(to, from, next) {
    // Checks if the user is a staff
    if (store.getters.profile.role === "staff") {
      next(from);
    } else {
      next();
    }
  },
  methods: {
    ...mapActions(["fetchSingleGroupUsers"]),
    removeuser(id) {
      this.removedId = id;
      this.id = "";
      this.removeGroupUserModal = true;
    },
    showRemoveUser(id) {
      if (this.RemoveUserShow(id)) {
        this.id = "";
      } else {
        this.id = id;
      }
    },
    RemoveUserShow(id) {
      if (id == this.id) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    singlegroup: {
      handler: function() {
        this.dataTable = this.singlegroup.users;
      },
      deep: true,
    },
    showModal(val) {
      if (val === this.$route.name) {
        this.addGroupUserModal = true;
      }
      this.$emit("close_modal");
    },
  },
  mounted() {
    this.dataTable = this.singlegroup.users;
    this.fetchSingleGroupUsers({ id: this.$route.params.id }).then(() => {});
  },
};
</script>

<style scoped>
td {
  /* border-bottom: 1px rgba(0, 0, 0, 0.1) solid; */
}
th.active {
  color: #fff;
}
.removedevice-dropdown {
  left: -1000%;
}
</style>
<i18n>
{
	"en": {
		"add_user": "Add User",
		"email": "Email",
		"full_name": "Full Name",
		"no_user": "You have no users yet",
		"rem_user": "Remove User",
		"user_rights": "User Rights",
		"users": "Users",
		"users_ass": "Users assigned to this group will see all devices in this group."
	},
	"es": {
		"add_user": "Agregar usuario",
		"email": "Email",
		"full_name": "Nombre completo",
		"no_user": "Aún no tienes usuarios",
		"rem_user": "eliminar usuario",
		"user_rights": "Derechos de usuario",
		"users": "Usuarios",
		"users_ass": "Los usuarios asignados a este grupo verán todos los dispositivos de este grupo."
	},
	"fr": {
		"add_user": "Ajouter un utilisateur",
		"email": "E-mail",
		"full_name": "Nom et prénom",
		"no_user": "Vous n'avez pas encore d'utilisateurs",
		"rem_user": "Supprimer l'utilisateur",
		"user_rights": "Droits de l'utilisateur",
		"users": "Utilisateurs",
		"users_ass": "Les utilisateurs affectés à ce groupe verront tous les appareils de ce groupe."
	},
	"sw": {
		"add_user": "BONYEZA USER",
		"email": "Barua pepe",
		"full_name": "Jina kamili",
		"no_user": "Bado huna watumiaji",
		"rem_user": "Ondoa mtumiaji",
		"user_rights": "Haki za Mtumiaji",
		"users": "Watumiaji",
		"users_ass": "Watumiaji waliowekwa kwenye kikundi hiki wataona vifaa vyote kwenye kikundi hiki."
	}
}
</i18n>
